/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

 import * as React from "react"
 import { useStaticQuery, graphql } from "gatsby"
 
 const Bio = () => {
   return (
     <div className="bio">
       <div className="bio-avatar" >J + A</div>
        <div>
         <p>
           By <strong>Jayla and Artur</strong> who to like post about rugs, travel and more!
           </p>
           <p>
           <a href={`https://youtube.com/c/jaylaandartur`}>
             You should subscribe to their YouTube channel!
           </a>
           </p>
           </div>
         
     </div>
   )
 }
 
 export default Bio